import { Injectable } from '@angular/core';
import { CustomAuthServiceService } from './custom-auth-service.service';
import { CustomPermissionKey } from '../models/user';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  constructor(private authService: CustomAuthServiceService) {}

  has(key: CustomPermissionKey): boolean {
    return !!this.authService.currentUserValue()?.customPermissions?.[key];
  }
}
